import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { EchexbaseComponent } from '../echexbase/echexbase.component';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';
import { Location } from '@angular/common';

@Component({
  selector: 'echexpayment-managepermissions',
  templateUrl: './managepermissions.component.html',
  styleUrls: ['./managepermissions.component.css']
})
export class ManagepermissionsComponent extends EchexbaseComponent implements OnInit {
	echexMerchantPermission: any = {};
	public token: string;
	public id: string;
	public url: string;
	public role_id: string;
	public permissionList: {};
	public userPermissionList: {};
	busy: Subscription;
	
	constructor(protected echexpaymentService: EchexpaymentService,private Location : Location,  protected userService :UserService, protected router: Router, protected toastr: ToastrService, protected  route: ActivatedRoute, protected localStorageService: LocalstorageService) { 
	super(route, router, toastr, userService, echexpaymentService, localStorageService);
		this.router = router;
		var currentUser = this.localStorageService.getData("currentUserToken");
		this.token =  currentUser.data.user_token;
		var userDetails = this.localStorageService.getData("currentUser");
		this.id =  userDetails._id;
		this.role_id = userDetails.role_id;
	}

	ngOnInit() {
	   this.getPermissionsAsPerRole();
	}
  
	goBack(){
       this.Location.back();
	}
	// Get Default permission as per role
	getDefaultPermissionsAsPerRole() {
		let params: any = this.route.snapshot.params;
		let data = {
		  token:this.id,
		  user_token:this.token,
		  id:params.id,
		  role_id: params.role_id
		}
		let responseData = <any>{};
		this.busy = this.echexpaymentService.getMerchantPermissionList(data).subscribe(
		   response => {
			responseData = response;
			this.permissionList = responseData.data;
		   },
		   error => {
			 responseData = error;
			 this.toastr.error(responseData.error.message, 'Failed!');
		   }
		);
	}
	// Get Default permission as per role
	getPermissionsAsPerRole() {
		let params: any = this.route.snapshot.params;
		let data = {
		  user_token:this.token,
		  token:params.id,
		  id:params.id,
		  role_id: params.role_id
		}
		
		let responseData = <any>{};
		this.busy = this.echexpaymentService.getEachUserPermission(data).subscribe(
		   response => {
		    responseData = response;
			var permissionArray = new Array(); 
			var i = 0;
			var obj = responseData.data.settings.permissions;
			var usersJson: any[] = Array.of(responseData.data.settings.permissions);
			this.userPermissionList = usersJson;
			this.getDefaultPermissionsAsPerRole();
		   },
		   error => {
			 responseData = error;
			 this.toastr.error(responseData.error.message, 'Failed!');
		   }
		);
	}


}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/managepermissions/managepermissions.component.ts